import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export default function DeleteMasterDataModal({
  modalData,
  deleteUser,
  isOpen,
  onClose,
  selectedKey,
  isDisable,
}) {
  const { t } = useTranslation('MasterData');

  const handleDelete = () => {
    console.log('user to be dleted', modalData.id);
    deleteUser(modalData.id);
  };

  useEffect(() => {
    const modalElement = document.getElementById('permissions-delete');
    const modalInstance = new window.bootstrap.Modal(modalElement, {
      backdrop: 'static',
      keyboard: false,
    });

    if (isOpen) {
      modalInstance.show();
    } else {
      modalInstance.hide();
    }
    return () => {
      modalInstance.hide();
    };
  }, [isOpen]);
  // Mapping for Modal Title and Input Label
  const keyMappings = {
    MASTER_DATA_CUSTOMER_CATEGORY: t('CUSTOMERCATEGORY'),
    MASTER_DATA_AREA: t('AREA'),
    MASTER_DATA_DISTRICT: t('DISTRICT'),
    MASTER_DATA_DELIVERY_STATUS: t('DELIVERYSTATUS'),
    MASTER_DATA_LOGISTIC_LINE: t('LOGISTICLINE'),
    MASTER_DATA_ORDER_STATUS: t('ORDERSTATUS'),
    MASTER_DATA_ORIGIN: t('ORIGIN'),
    MASTER_DATA_PAYMENT_METHOD: t('PAYMENTMETHOD'),
    MASTER_DATA_PAYMENT_STATUS: t('PAYMENTSTATUS'),
    MASTER_DATA_PROCESS_LOCATION: t('PROCESSLOCATION'),
    MASTER_DATA_PROCESS_CATEGORY: t('PROCESSCATEGORY'),
    MASTER_DATA_SPECIFICATION_UNIT: t('SPECIFICATIONUNIT'),
    // "MASTER_DATA_SPECIFICATION_VALUE": "Specification Value"
    MASTER_DATA_PRODUCT_UNIT: t('PRODUCTUNIT'),
  };
  // const modalTitle = `Delete ${keyMappings[selectedKey] || ""}`;

  return (
    <div
      className="modal fade"
      id="permissions-delete"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-body">
            <span className="delete">
              <img src="images/delete-simple.svg" alt="" />
            </span>
            <div className="text">
              <h5>
                {t('AREYOUSUREYOUWANTTODELETE')} {keyMappings[selectedKey]}?
              </h5>
              {/* <h6>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry.
              </h6> */}
            </div>
            <div className="bottom-button">
              <button
                className="cancel"
                onClick={() => {
                  onClose('delete');
                }}
              >
                {t('CANCEL')}
              </button>
              <button
                onClick={handleDelete}
                className={`sure ${isDisable ? 'disable-btn' : ''}`}
                disabled={isDisable}
              >
                {t('YESIMSURE')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
